import {
  MARKET_MODES,
  MARKET_MODE_STATUS,
  Market
} from '../market';

const MAX_MESSENGER_FAQ = [
  {
    title: 'Используются ли боты или программы?',
    isH3: false,
    text:
      <p>
        Нет мы биржа заданий, где исполнители реальные люди. 
        <br />
        Все задания выполняются вручную реальными людьми с разных устройств и с личных аккаунтов.
      </p>
  },
  {
    title: 'Можно ли получить реальных подписчиков в MAX?',
    isH3: false,
    text:
      <p>
        Исполнители могут подписываться на каналы или аккаунты в рамках сценария задания. 
        <br />
        Поведение пользователей является естественным и не гарантирует сохранение подписки.
      </p>
  },
  {
    title: 'Есть ли гарантии?',
    isH3: false,
    text:
      <p>
        Да, если задание сделал исполнитель не корректно, то вы можете сменить исполнителя - это бесплатно. 
        <br />
        Оплачивайте только те отчеты, которые вас устроят.
      </p>
  },
  {
    title: 'Какие отчёты предоставляются?',
    isH3: false,
    text:
      <p>
        Каждый исполнитель сдаёт текстовый отчёт о выполнении задания, что позволяет контролировать качество действий. 
        <br />
        Если отчет не устроит, то можно отправить на доработку или сменить исполнителя. Это бесплатно.
      </p>
  },
  {
    title: 'Подходит ли сервис для тестирования продвижения в MAX?',
    isH3: false,
    text:
      <p>
        Да. Платформа подходит для анализа реакции аудитории, тестирования гипотез и пользовательских сценариев.
        <br />
        <br />
        Это накрутка подписчиков в MAX?
        <br />
        <br />
        В поисковых системах услугу часто называют «накрутка подписчиков MAX», однако фактически речь идёт о продвижении через реальные действия пользователей без использования ботов и автоматизации.
      </p>
  },
];

const MAX_MESSENGER_ARTICLE = {
  title: 'Накрутка подписчиков в MAX: в чём разница между ботами и реальными людьми',
  content: <div>
    Если вам нужна накрутка подписчиков в Макс, важно понимать разницу между ботами и живыми пользователями.
    <br />
    Мы работаем исключительно с реальными исполнителями и микрозадачами, без автоматизации и программ.
    <br />
    <br />
    <h3>Боты: быстрый рост без ценности</h3>
    <br />
    Боты — это автоматические аккаунты или программы, которые массово подписываются на каналы и профили. 
    <br />
    Их основное преимущество — скорость: цифры растут почти мгновенно. Но на этом плюсы заканчиваются.
    <br />
    Такие подписчики не читают сообщения, не участвуют в обсуждениях и не совершают целевых действий. 
    <br />
    Более того, боты легко распознаются алгоритмами платформ: одинаковые паттерны поведения, отсутствие активности, подозрительные устройства и IP-адреса. 
    <br />
    В результате аккаунт может столкнуться с ограничением охватов или потерей части аудитории.
    <br />
    Кроме того, бот-подписчики искажают аналитику: кажется, что аудитория большая, но реакции и вовлечённость остаются на нуле.
    <br />
    <br />
    <h3>Реальные люди: медленнее, но безопаснее</h3>
    <br />
    Продвижение через реальных пользователей строится иначе. 
    <br />
    В этом случае речь идёт не о продаже подписчиков, а о выполнении микрозадач живыми людьми: переходы, просмотр контента, ознакомление с каналом и добровольная подписка в рамках пользовательского сценария.
    <br />
    Такие действия выполняются вручную, с разных устройств и аккаунтов, без автоматизации. 
    <br />
    Подписчики в этом случае — реальные пользователи, которые могут читать контент, реагировать и отписываться так же естественно, как любая живая аудитория.
    <br />
    Важно понимать: никто не может гарантировать сохранение подписки или рост метрик. 
    <br />
    Но именно такой подход считается более устойчивым и безопасным, поскольку имитирует естественное поведение аудитории, а не техническую накрутку.
    <br />
    <br />
    <h3>Что в итоге выбрать</h3>
    <br />
    Если под «накруткой подписчиков в MAX» подразумевается краткосрочный рост цифры — боты дадут быстрый, но пустой результат. Если же цель — тестирование интереса, первичная активность и более естественное развитие канала, работа с реальными пользователями выглядит предпочтительнее.
    <br />
    <br />
    В современном продвижении важны не сами цифры, а качество аудитории и её поведение. 
    <br />
    Именно это отличает формальную накрутку от осознанного роста.Платформы усилили контроль за искусственными методами стимулирования активности. 
    <br />
    Но оптимизация под ПФ — не нарушение, если она направлена на улучшение пользовательского опыта. 
    <br />
    Например, изменение описания, улучшение фото, добавление ответов на частые вопросы — это формы поведенческого тестирования, а не манипуляции.
  </div>
};

const STEP_TWO_TITLE_FAQ = <p>
  Почему при добавлении одного действия в калькуляторе появляются дополнительные действия?
  <br />
  <br />
  Сервис формирует уникальные сценарии для каждого исполнителя, и каждый сценарий начинается для нового исполнителя с перехода на канал по переданной вами ссылке.
</p>;

const CHAIN_PRICE = 6;
const CHAIN_STEPS = 4;

const STEP_PRICE = Number((CHAIN_PRICE / CHAIN_STEPS).toFixed(1));

const ACTIONS = [
  {
    type: 'MAIN.SUBSCRIBE',
    icon: "people",
    iconHome: "home-people",
    title: 'Активная подписка (человек)',
    titleComment: '+\u00a0просмотр\u00a0постов +\u00a0просмотр\u00a0профиля +\u00a0отчет\u00a0о\u00a0работе',
    initialShare: 0.9,
    price: STEP_PRICE,
    activityType: 'Подписка',
  },
  {
    type: 'MAIN.LIKE',
    icon: "like",
    iconHome: "home-star",
    title: 'Поставить лайк / реакцию на пост',
    titleComment: '+\u00a0просмотр\u00a0постов +\u00a0просмотр\u00a0профиля +\u00a0отчет\u00a0о\u00a0работе',
    initialShare: 0,
    activityType: 'Лайк',
  },
  /* {
    type: 'MAIN.REPOST',
    icon: "message",
    iconHome: "home-repost",
    title: 'Сделать репост поста в ВК',
    initialShare: 0.1,
    activityType: 'Репост',
  }, */

  { type: 'ALWAYS.OPEN', icon: "open", iconHome: "home-open", title: 'Открыть MAX', initialShare: 1 },

  {
    type: 'ALWAYS.SEARCH',
    icon: "search",
    iconHome: "home-search",
    title: 'Найти канал / группу',
    titleComment: 'должны быть публичными',
    initialShare: 1,
    price: STEP_PRICE,
  },

  { type: 'EXTRA.SEE', icon: "glasses", iconHome: "home-glasses", title: 'Посмотреть последние 7 постов', initialShare: 0.7, price: STEP_PRICE },
  /* { type: 'EXTRA.PROFILE', icon: "click", iconHome: "home-click", title: 'Посмотреть профиль', initialShare: 0.3, price: STEP_PRICE }, */

  {
    type: 'MAIN.SURVEY',
    icon: "click",
    iconHome: "home-click",
    title: 'Поучаствовать в опросе',
    titleComment: 'должен быть активным',
    initialShare: 0,
    activityType: 'Опрос',
  },
];

const MAIN_PAGE_TITLES = [
  {
    iconHome: "home-action",
    title: "Поведенческая активность",
    path: "/nakrutka-podpischikov-max",
    target: '_self',
    statusForHomePage: MARKET_MODE_STATUS.HIT,
  },
  {
    iconHome: "home-subscribe",
    title: "Подписка + просмотры",
    path: "/nakrutka-podpischikov-max",
    target: '_self',
  },
  {
    iconHome: "home-like",
    title: "Лайк + просмотры",
    path: "/nakrutka-podpischikov-max",
    target: '_self',
  },
  /* {
    iconHome: "home-repost",
    title: "Репост в MAX",
    path: "/nakrutka-podpischikov-max",
    target: '_self',
  }, */
  {
    iconHome: "home-open",
    title: "Открыть MAX",
    path: "/nakrutka-podpischikov-max",
    target: '_self',
  },
  {
    iconHome: "home-search",
    title: "Найти канал / группу",
    path: "/nakrutka-podpischikov-max",
    target: '_self',
  },
  {
    iconHome: "home-glasses",
    title: "Посмотреть последние 7 постов",
    path: "/nakrutka-podpischikov-max",
    target: '_self',
  },
  {
    iconHome: "home-click",
    title: "Посмотреть профиль",
    path: "/nakrutka-podpischikov-max",
    target: '_self',
  },
  /* {
    iconHome: "home-click",
    title: "Поучаствовать в опросе",
    path: "/nakrutka-podpischikov-max",
    target: '_self',
  } */
];

const MAX_MESSENGER_KEYWORDS = [
  'Max', 'max', 'Макс', 'макс',
];

class MaxMessengerClass extends Market {

  id = 'max';
  host = 'max.ru';
  url = 'https://max.ru/';

  title = 'MAX';

  isMarketplace = false;

  icon = "max";
  titlePlaces = 'Max';
  statusForHomePage = MARKET_MODE_STATUS.POPULAR;
  mainPageTitles = MAIN_PAGE_TITLES;

  categories = [];

  chainsPerDayNormal = 400 / 30;

  chainPrice = CHAIN_PRICE;
  chainsMin = 10;
  chainsMax = 500;

  chainsDefault = 30;

  reviewPrice = 0;

  chainsStep = 10;
  viewsStep = 1;

  keywords = MAX_MESSENGER_KEYWORDS;

  targetLinkComment = <span>Укажите тут адрес вашего <b>открытого</b> канала в MAX</span>;
  targetLinkCommentShort = <span>Укажите ссылку на <b>открытый</b> канал</span>;

  modes = [
    {
      id: MARKET_MODES.CHAINS,
      title: 'ПФ',
      navigateTitle: 'Активность: подписки, вовлеченность',
      path: '/nakrutka-podpischikov-max',
      rating: 0.20,
      icon: "people",
      iconForHomePage: "home-action",
      status: MARKET_MODE_STATUS.REGULAR,
      meta: {
        title: `Продвижение и накрутка подписчиков в Макс - от ${CHAIN_PRICE / CHAIN_STEPS} руб. (MAX) без ботов`,
        description: 'Закажите накрутку подписчиков ЛЮДИ в MAX через Boostclick.',
        canonical: '/nakrutka-podpischikov-max',
      },
      intro: {
        title: 'Продвижение в MAX через реальных пользователей',
        comment: 'Через микрозадачи и участие реальных пользователей',
        points: [
          'Без ботов',
          'Только уникальные пользователи',
          'Реальные подписчики',
          'Подробные отчеты',
          'Гибкие настройки проекта',
        ]
      },
      howItWorks: [
        'Распределите активности',
        'Укажите ссылку на MAX канал / чат',
        'Сервис создаст задания для исполнителей',
        'Исполнители выполнят задания и пришлют отчеты',
        'Проверьте отчеты, если все верно примите их, если есть ошибки, то смените исполнителя',
      ],
      stepPhrase1: 'Настройте параметры привлечения подписчиков в MAX',
      stepPhrase2: 'Укажите информацию для поиска канала',
      stepTwoTitleFaq: STEP_TWO_TITLE_FAQ,
      calculatorTitle: 'Продвижение канала в MAX*',
      titleFAQ: "Вопрос-ответ",
      faq: MAX_MESSENGER_FAQ,
      article: MAX_MESSENGER_ARTICLE,
      actions: ACTIONS,
      notice: [
        '* Сервис сгенерирует уникальные цепочки действий с учетом поисковых запросов.',
        'Boostclick предоставляет доступ к платформе, где исполнители получают задания и переходят в ваш MAX-канал по ссылке.',
        'Каждый пользователь выполняет задания вручную — это может включать просмотр канала, подписку и другие действия.',
        'Поведение варьируется в зависимости от сценария и количества действий в рамках проекта.',
        'Сроки выполнения зависят от объема и настроек задания.',
      ]
    },
  ];

  actionsMap = ACTIONS.reduce((map, action) => {
    map[action.type] = action; return map;
  }, {});

  emptyUrlStr = 'Укажите ссылку на канал или группу';
  invalidUrlStr = 'Укажите корректную ссылку на канал или группу';
}

const MaxMessenger = new MaxMessengerClass();
export default MaxMessenger;
